/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputeProviderHealth,
  ComputeProviderHealth$inboundSchema,
  ComputeProviderHealth$Outbound,
  ComputeProviderHealth$outboundSchema,
} from "./computeproviderhealth.js";

export type ComputeProviderHealthList = {
  nextCursor: string | null;
  total: number;
  data: Array<ComputeProviderHealth>;
};

/** @internal */
export const ComputeProviderHealthList$inboundSchema: z.ZodType<
  ComputeProviderHealthList,
  z.ZodTypeDef,
  unknown
> = z.object({
  next_cursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeProviderHealth$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "next_cursor": "nextCursor",
  });
});
/** @internal */
export type ComputeProviderHealthList$Outbound = {
  next_cursor: string | null;
  total: number;
  data: Array<ComputeProviderHealth$Outbound>;
};

/** @internal */
export const ComputeProviderHealthList$outboundSchema: z.ZodType<
  ComputeProviderHealthList$Outbound,
  z.ZodTypeDef,
  ComputeProviderHealthList
> = z.object({
  nextCursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeProviderHealth$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    nextCursor: "next_cursor",
  });
});

export function computeProviderHealthListToJSON(
  computeProviderHealthList: ComputeProviderHealthList,
): string {
  return JSON.stringify(
    ComputeProviderHealthList$outboundSchema.parse(computeProviderHealthList),
  );
}
export function computeProviderHealthListFromJSON(
  jsonString: string,
): SafeParseResult<ComputeProviderHealthList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeProviderHealthList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeProviderHealthList' from JSON`,
  );
}
